import {useSyncCenter} from "../../../syncstream/SyncCenterProvider";
import {useEffect, useState} from "react";

const useDashboardData = () => {
  const [indexedDbData, setIndexedDbData] = useState<{ dataType: string, numberOfRecords: number, queueSize: string }[]>([{ dataType: '', numberOfRecords: 0, queueSize: '' }]);

  const syncCenter = useSyncCenter();
  useEffect(() => {
    setIndexedDbData([
      {dataType: 'Drugs', numberOfRecords: syncCenter.drugs.store.length, queueSize: ''},
      {dataType: 'Patients', numberOfRecords: syncCenter.patients.store.length, queueSize: ''},
      {dataType: 'Patient Movements', numberOfRecords: syncCenter.patientMovements.store.length, queueSize: ''},
      {dataType: 'Packed Patients Days', numberOfRecords: syncCenter.packedPatientDays.store.length, queueSize: ''},
      {dataType: 'Packed Patient PRN Medication', numberOfRecords: syncCenter.packedPatientPrnMedications.store.length, queueSize: ''},
      {dataType: 'Syringe Driver Runs', numberOfRecords: syncCenter.syringeDriverRun.store.length, queueSize: syncCenter.syringeDriverRun.queue.queueLength.toString()},
      {dataType: 'Patch Applications', numberOfRecords: syncCenter.patchApplications.store.length, queueSize: syncCenter.patchApplications.queue.queueLength.toString()},
      {dataType: 'Dose Rounds', numberOfRecords: syncCenter.rounds.store.length, queueSize: syncCenter.rounds.queue.queueLength.toString()},
      {dataType: 'Orders', numberOfRecords: syncCenter.orders.store.length, queueSize: ''},
    ])
  }, [
      syncCenter.drugs.store,
      syncCenter.patients.store,
      syncCenter.patientMovements.store,
      syncCenter.packedPatientDays.store,
      syncCenter.packedPatientPrnMedications.store,
      syncCenter.syringeDriverRun.store,
      syncCenter.syringeDriverRun.queue,
      syncCenter.patchApplications.queue,
      syncCenter.rounds.store,
      syncCenter.orders.store
  ]);

  return {indexedDbData};
}

export default useDashboardData;
